import { render, staticRenderFns } from "./PopOrderWangong.vue?vue&type=template&id=5900ca84&scoped=true&"
import script from "./PopOrderWangong.vue?vue&type=script&lang=js&"
export * from "./PopOrderWangong.vue?vue&type=script&lang=js&"
import style0 from "./PopOrderWangong.vue?vue&type=style&index=0&id=5900ca84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5900ca84",
  null
  
)

export default component.exports